import { remember, serializeDataToCacheKey } from '@tuic/cache';
import { logger } from '@tuic/logger';

import { Pcl } from '../../index';
import { CacheTag } from '../../utils';

import type { Theme } from '../../generated/pcl';
import type { Locale } from '@tuic/i18n';

/**
 * Fetches the theme content of given tripCode.
 */
const getTripThemeContent = async (
  tripCode: string,
  locale: Locale,
): Promise<Theme | null> => {
  const { data, error } = await Pcl.getTripsByTripCodeThemeContent({
    path: { tripCode },
    query: { locale },
  });

  if (error) {
    logger.error(
      `Could not fetch theme content. Trip: ${tripCode}, Locale: ${locale}`,
    );
    logger.error(error);

    return null;
  }

  return data ?? null;
};

export const cachedGetTripThemeContent = (
  tripCode: string,
  locale: Locale,
): Promise<Theme | null> =>
  remember(
    serializeDataToCacheKey([
      CacheTag.pcl,
      'getTripThemeContent',
      locale,
      tripCode,
    ]),
    () => getTripThemeContent(tripCode, locale),
    {
      tags: [CacheTag.pcl, CacheTag.tripResource, CacheTag.getTripThemeContent],
      ttl: 600,
    },
  );
